import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UiTranslateModule } from '@fcom/ui-translate';
import { IconsModule, UiComponentsModule } from '@fcom/ui-components';
import { ComponentsModule } from '@fcom/common/components/components.module';
import { PipesModule } from '@fcom/common/pipes/pipes.module';
import { GtmModule } from '@fcom/common/gtm/gtm.module';

import { BookingSummaryComponent } from './booking-summary.component';
import { BookingSummaryFlightComponent } from './flight/booking-summary-flight.component';
import { BookingSummarySectionComponent } from './section/booking-summary-section.component';
import { BookingSummaryTravelerComponent } from './traveler/booking-summary-traveler.component';
import { BookingSummaryAncillaryComponent } from './ancillary/booking-summary-ancillary.component';
import { CommonBookingComponentsModule } from '../../common-booking.module';

@NgModule({
  imports: [
    CommonBookingComponentsModule,
    CommonModule,
    ComponentsModule,
    PipesModule,
    GtmModule,
    UiTranslateModule,
    IconsModule,
    UiComponentsModule,
  ],
  declarations: [
    BookingSummaryComponent,
    BookingSummaryFlightComponent,
    BookingSummarySectionComponent,
    BookingSummaryTravelerComponent,
    BookingSummaryAncillaryComponent,
  ],
  exports: [BookingSummaryComponent],
})
export class BookingSummaryModule {}
